import { render, staticRenderFns } from "./VerifyAndUpgrade.vue?vue&type=template&id=d66b891a"
import script from "./VerifyAndUpgrade.vue?vue&type=script&lang=js"
export * from "./VerifyAndUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports